// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wn_a bhy_b","TwoDimsListFeature__item":"wn_b bhy_we","TwoDimsListFeature__item__text":"wn_c bhy_vt"};